import * as React from 'react';
import * as ReactDOM from 'react-dom';
import classNames from 'classnames';
import { Subscription } from 'rxjs/Subscription';
import { App } from '../interfaces';
import Add from 'material-ui-icons/Add';
import { DateTime } from 'luxon';

export interface DayProps {
  date: DateTime;
  controller: App.Schedule.CalendarController
}

export interface DayState {
  notInCurrentMonth: boolean;
  isToday: boolean;
}

export class Day extends React.Component<DayProps, DayState> {

  state = {
    notInCurrentMonth: false,
    eventsForDay: [],
    isToday: false
  };
  currentMomentSub: Subscription;

  componentWillMount() {

    this.currentMomentSub = this.props.controller.currentMoment.subscribe(
    (currentMoment) => {

      

      const notInCurrentMonth = !currentMoment.hasSame(this.props.date, 'month');

      const now = DateTime.local();

      const isToday = now.hasSame(this.props.date, 'day');

      this.setState( { notInCurrentMonth, isToday });

    }
  );

  }

  componentWillUnmount() {

    if(this.currentMomentSub) { this.currentMomentSub.unsubscribe(); }

  }

  render() {

    const classes = classNames({
      'day': true,
      'day--not-in-current-month': this.state.notInCurrentMonth,
      'day--is-odd': this.props.date.ordinal % 2,
      'day--is-today': this.state.isToday
    });

    return (<div className={classes}>
        <div className={'day__header'}>

          { this.props.controller.renderDayActions(this.props.date) }

          <div className={'day__label day__label--day-number'}>

            { this.props.date.toFormat('d') }

          </div>
          <div className={'day__label day__label--full-date'}>

            { this.props.date.toFormat('cccc LLLL d') }

          </div>

        </div>

        <div className={'day__event-area'}>

          { this.props.controller.renderDayEvents(this.props.date) }

        </div>

    </div>);

  }


}


// WEBPACK FOOTER //
// ./resources/src/components/schedule/day.tsx